//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/Report.js";
import "../Report/Report.BaseItem.js";
let d=[[],[[["imageFile","displayName"],"CreateImage",{R_:{pReportImage:"Report.ReportImage"}},2,0],[["pReportImage"],"CopyImage",{R_:{pReportImageCopy:"Report.ReportImage"}},1,0],[["numReportImages","pReportImages"],"GetImages",{},0,0],[["pReportImages","newLocation","pReferencedImage"],"MoveImages",{},3,0],[[],"DeleteImages",{},0,0]],[]];
SPLM.Report.ImagesGroupItem = class extends SPLM.Report.BaseItem{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.Report.ImagesGroupItem";
        SPLM.c$d(this.Class,d);d=[];
    }
};

export default SPLM;